export default __webpack_public_path__ + "static/media/beratung.de.5d3325d0.webp";